import * as React from 'react';
import S from 's-js';
import * as Promise from 'bluebird';
import { Location } from 'lib/componentLocation';
import { RequestSignal } from 'lib/requestSignal';

export interface IRoute {
    view : React.ReactElement<any>;
    load? : () => Promise<Location>;
    reflectState? : () => Location;
    leave? : (req : Location) => Promise<Location>;
}

export type RouteTable = { [name: string] : ((request : Location) => IRoute) | undefined }

export class Router {
    running = S.data(false);
    route : () => IRoute | null;

    constructor(
        public routes : RouteTable, 
        location : RequestSignal<Location | null>, 
        defaultLocation : Location
    ) { 
        let currentState = defaultLocation;
        const request = S.data(currentState),
            locationWatcher = S(() => { 
                const loc = location(); 
                if (loc && !currentState.eq(loc))
                    request(currentState = loc);
            }),
            route = S(() => {
                if (!this.running()) return null;

                const req = request(),
                    route = this.routes[req.name];
                if (!route) throw new Error("no route defined with name " + req.name);
                return route(req);
            }),
            stateReflector = S(() => {
                const r = route(), 
                    state = r && r.reflectState && r.reflectState();
                if (state)
                    location(currentState = state, true);
            });

        this.route = route;
    }
}


// WEBPACK FOOTER //
// ./lib/componentRouter.ts